import { Component } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-sar-confirmation-box',
    templateUrl: './sar-confirmation-box.component.html',
    styleUrls: ['./sar-confirmation-box.component.scss'],
    standalone: false
})
export class SarConfirmationBoxComponent {

  headerOption: string = ''
  confirmMessage: string = '';
  isRejectedCancel?: boolean = false;
  constructor(public dialog: DialogRef) { }

  close(actionName: string) {
    this.dialog.close({ action: actionName });

  }
}
